<br>
<!-- Nuevo diseño: dos columnas, izquierda información del cupón, derecha formulario de login/registro -->
<div class="coupon-dialog-grid">
  <div class="coupon-info">
    <h2>{{ data.title }}</h2>
    <img [src]="data.urlImage" alt="Cupón" class="coupon-image" />
    <p class="dialog-message">{{ data.message }}</p>
    <div class="coupon-code"><strong>Cupón:</strong> {{ data.code }}</div>
  </div>

  <div class="coupon-form">
    <h3>Iniciar sesión / Registrarse</h3>
    <form [formGroup]="contactForm" (ngSubmit)="onLoginClick()">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Correo</mat-label>
        <input matInput type="email" formControlName="email" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Contraseña</mat-label>
        <input matInput [type]="hide ? 'password' : 'text'" formControlName="password" />
        <button mat-icon-button matSuffix type="button" (click)="hide = !hide">
          <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Teléfono (para registro)</mat-label>
        <input matInput type="tel" formControlName="phone" />
      </mat-form-field>

      <div class="actions">
        <button mat-flat-button color="primary" type="button" (click)="onLoginClick()" [disabled]="isLoginFormInvalid() || loadingLogin">
          <mat-spinner *ngIf="loadingLogin" diameter="20"></mat-spinner>
          <span *ngIf="!loadingLogin">Ingresar</span>
        </button>
        <button mat-flat-button color="accent" type="button" (click)="onRegister()" [disabled]="isRegisterFormInvalid() || loadingRegister">
          <mat-spinner *ngIf="loadingRegister" diameter="20"></mat-spinner>
          <span *ngIf="!loadingRegister">Registrarse</span>
        </button>
      </div>

      <div class="message" *ngIf="message" [ngStyle]="{ color: 'green' }">{{ message }}</div>
      <div class="error" *ngIf="error" [ngStyle]="{ color: 'red' }">{{ error }}</div>

    </form>
    <div class="close-link">
      <button mat-button (click)="onClose()">Cerrar</button>
    </div>
  </div>
</div>